import { createSelector } from 'reselect';

import { convertListToObjectBy } from 'utils/fn';

// ===
import { getBodyData } from '../../selectors';

/** navigation data */
const getNavigationData = (state) => getBodyData(state).navigation || {};
export const getNavigationTitle = (state) => getNavigationData(state).title;
export const getNavigationReferenceTitle = (state) => getNavigationData(state).referenceTitle;
export const getNavigationContacts = (state) => getNavigationData(state).contacts;

export const getContactsPhone = (state) => getNavigationContacts(state).phones[0];
export const getContactsNote = (state) => getNavigationContacts(state).note;
export const getAgreementDataUrl = (state) => getNavigationContacts(state).agreementDataUrl;

/** search */
const getSearchData = (state) => getBodyData(state).search || {};
export const getSearchPlaceholder = (state) => getSearchData(state).placeholder;
export const getSearchUrl = (state) => getSearchData(state).url;
export const getSearchQuery = (state) => getBodyData(state).query || '';
export const getPageIsSearch = (state) => !!getBodyData(state).isSearchPage;
export const getSearchSuggestionsUrlTemplate = (state) =>
  getSearchData(state).suggestionsUrlTemplate;

/** other data */
export const getBreadcrumbs = (state) => getBodyData(state).breadcrumbs;

/**
 * collection data
 */

/** first level collection data */
export const getMainCollectionsData = (state) =>
  getNavigationData(state).collections || { list: [] };
/**
 * AB test, after finish => rename getMainCollectionsData back to getMainCollections
 * TODO: Remove, when collection tariffy ABTest is done and/or refactor to single func for every selector
 */
export const getMainCollections = createSelector(getMainCollectionsData, (collections) => {
  // скрыть коллекцию для главной страницы
  const list = collections.list.filter((l) => l.slug !== 'recommended');
  return {
    ...collections,
    list: list.map((item) => ({
      ...item,
      name: item.name || '',
    })),
  };
});

export const getMainCollectionSlug = (state) => getMainCollections(state).activeSlug || null;
export const getMainCollectionList = (state) => getMainCollections(state).list || [];
export const getMainCollectionDict = createSelector(
  getMainCollectionList,
  convertListToObjectBy('slug'),
);
export const getMainCollectionData = (state) =>
  getMainCollectionDict(state)[getMainCollectionSlug(state)] || {};
export const getMainCollectionName = (state) => getMainCollectionData(state).name;

/** second level collection data */
export const getSubCollections = (state) =>
  getMainCollectionData(state).collections || { list: [] };
export const getSubCollectionSlug = (state) => getSubCollections(state).activeSlug || null;
export const getSubCollectionList = (state) => getSubCollections(state).list || [];
export const getSubCollectionDict = createSelector(
  getSubCollectionList,
  convertListToObjectBy('slug'),
);
export const getSubCollectionData = (state) =>
  getSubCollectionDict(state)[getSubCollectionSlug(state)] || {};
export const getSubCollectionName = (state) => getSubCollectionData(state).name;

export const getCurrentCategoriesPath = (state) =>
  `${getMainCollectionName(state)}|${getSubCollectionName(state)}`;
export const getCurrentCategoriesPathYM = (state) => getMainCollectionName(state)?.toLowerCase();
